"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEnvironment = void 0;
var AppEnvironment;
(function (AppEnvironment) {
    AppEnvironment["DEVELOPMENT"] = "development";
    AppEnvironment["PRODUCTION"] = "production";
})(AppEnvironment || (AppEnvironment = {}));
exports.AppEnvironment = AppEnvironment;
